import type { Layout } from '@/domains/productDiscovery/Listings/pages/Category/Category.model';
import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import { selectCategoryMetadata } from './category';

export const selectLayout = (
  state: SpartacuxProductDiscoveryDomainState,
): Layout | undefined => selectCategoryMetadata(state)?.layout;
